import * as React from 'react';
import { forwardRef } from 'react';
const Fallback = (props, ref) => {
    const prefixId = React.useId();
    return (React.createElement("svg", { viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props },
        React.createElement("g", { clipPath: `url(#$${prefixId}__clip0_4587_588)` },
            React.createElement("rect", { width: 40, height: 40, rx: 10, fill: "#A0A3B2" }),
            React.createElement("rect", { width: 40, height: 40, rx: 10, fill: "#A0A3B2" }),
            React.createElement("path", { d: "M11 11a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3 1.5 1.5 0 0 1-1.5 1.5h-15A1.5 1.5 0 0 1 11 11ZM11 29a1.5 1.5 0 0 1 1.5-1.5h15A1.5 1.5 0 0 1 29 29a3 3 0 0 1-3 3H14a3 3 0 0 1-3-3ZM9.312 15.468C8 16.185 8 17.34 8 19.65v.7c0 2.31 0 3.465 1.312 4.182 1.312.718 3.424.718 7.648.718h6.08c4.224 0 6.336 0 7.648-.718C32 23.815 32 22.66 32 20.35v-.7c0-2.31 0-3.465-1.312-4.182-1.312-.718-3.424-.718-7.648-.718h-6.08c-4.224 0-6.336 0-7.648.718Z", fill: "#fff" })),
        React.createElement("defs", null,
            React.createElement("clipPath", { id: `$${prefixId}__clip0_4587_588` },
                React.createElement("rect", { width: 40, height: 40, rx: 10, fill: "#fff" })))));
};
const ForwardRef = forwardRef(Fallback);
export default ForwardRef;
ForwardRef.displayName = 'Fallback';
//# sourceMappingURL=Fallback.js.map